import { useTablePagination } from "components/Table/hooks";

const getSharedProcesses = ({ page, pageSize = 10 }) => {
  const query = `
  query getSharedProcesses {
    sharedProcesses(first: ${pageSize}, offset: ${page * pageSize}) {
        edges {
            node {
                id
                name
                timesShared
            }
        }
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }`;

  const resolver = ({ data: { sharedProcesses } }) => {
    return {
      sharedProcesses: sharedProcesses.edges.map(({ node }) => {
        return { ...node };
      }),
      totalCount: sharedProcesses.totalCount,
    };
  };

  return { query, resolver };
};

const useSharedProcesses = () => {
  const {
    pageControl,
    updatePageControl,
    reloadData,
    loading,
    data,
    numOfFetches,
  } = useTablePagination(getSharedProcesses);

  return {
    pageControl: pageControl,
    updatePageControl: updatePageControl,
    initialLoading: loading && numOfFetches === 0,
    isReloading: loading && numOfFetches > 0,
    totalCount: data?.totalCount || 0,
    sharedProcesses: data?.sharedProcesses || [],
    reloadData: reloadData,
  };
};

export default useSharedProcesses;
